import { Box, Modal, Typography, useMediaQuery } from '@material-ui/core';
import React, { FC, useCallback, useEffect, useState } from 'react';
import theme from 'src/config/theme';
import TextField from '../forms/TextField';
import { Button } from '../buttons';
import { validate } from 'uuid';
import { FontAwesomeSpriteButton } from '../FontAwesomeLocal';
import { SpriteIconsSolid } from 'src/config/api/models/FontAwesome';
import { usePostImpersonateMutation } from '../../slices/impersonate/impersonateApi';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  minHeight: '30%',
  transform: 'translate(-50%, -50%)',
  width: '500px',
  overflowY: 'hidden',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
};

const styleSmallScreen = {
  height: '100%',
  overflowY: 'auto',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

type Props = {
  open: boolean;
  onClose: (params?: any) => void;
};

export type ImpersonateError = {
  code: string;
  message: string;
};

const ImpersonateModal: FC<Props> = ({ open, onClose, children }) => {
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [value, setValue] = React.useState('');
  const [error, setError] = useState<ImpersonateError>();
  const [impersonate, impersonateResponse] = usePostImpersonateMutation();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setError(undefined);
    setValue(event.target.value);
  };

  const handleClose = useCallback(() => {
    if (value !== '') {
      setValue('');
    }
    onClose();
  }, [onClose, value]);

  const handleImpersonate2 = () => {
    if (value && validate(value)) {
      impersonate(value);
    }
  };

  useEffect(() => {
    if (impersonateResponse.isSuccess) {
      impersonateResponse.reset();
      handleClose();
    }
  }, [handleClose, impersonateResponse]);

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={isSmallScreen ? styleSmallScreen : style}>
        <FontAwesomeSpriteButton
          buttonStyle={{
            position: 'absolute',
            top: '2rem',
            right: '1rem',
            transform: 'translate(10%, -50%)',
          }}
          icon={SpriteIconsSolid.XMARK}
          color={'grey'}
          iconSize="1x"
          onClick={() => handleClose()}
        ></FontAwesomeSpriteButton>
        <Typography variant="h1" style={{ marginBottom: '20px' }}>
          {'Impersonate User'}
        </Typography>
        <Typography variant="body1" color={'secondary'} style={{ fontWeight: '500' }}>
          {'As a superuser you can impersonate other non superuser profiles'}
        </Typography>
        {children}
        <div
          style={{
            display: 'flex',
            marginTop: '2rem',
            gap: '1rem',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <TextField
            error={!!error}
            style={{ flex: 1 }}
            id="outlined-basic"
            label="User id"
            variant="outlined"
            value={value}
            onChange={handleChange}
            helperText={error ? error.message : 'Valid UUID'}
          />
          <Button
            style={{ alignSelf: 'start' }}
            disabled={!validate(value)}
            onClick={handleImpersonate2}
          >
            Submit
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default ImpersonateModal;
